<mibp-dialog #dialog [buttons]="dialogButtons" hideCloseButton="true" width="1100" (buttonClick)="onDialogButton($event)" (closed)="onDialogClosed()">

  <div>
    <h1>Resource String Manager</h1>

    @if (isOpen) {
      <mibp-refiner #refiner [config]="refinerConfig" (filter)="filterResourceStrings($event)">
        @if (editMode) {
<div  style="
      /* margin: 20px; */
      position: absolute;
      left: 30px;
      top: 30px;
      width: 95%;
      height: 92%;
      box-shadow: aqua;
      box-shadow: 3px 3px 3px rgba(0,0,0,0.25);
      padding-bottom: 60px;
      background-color: #fdfdfd;
      z-index: 9000;
      border: 1px solid #eee;
      padding:20px;
  ">
            <div>
              @if (resourceStringForm) {
                <form [formGroup]="resourceStringForm" >
                  @if (isLoadingResourceEdit) {
                    <mibp-loader></mibp-loader>
                  }
                  @if (translation) {
                    <div [hidden]="isLoadingResourceEdit">
                      <div class="forms__row">
                        <label>Resource key</label>
                        <div style="display: flex">
                          <input style="flex: 1" type="text" disabled readonly value="{{ translation.resource.key }}" />
                        </div>
                      </div>
                      <div class="forms__row">
                        <label>Description</label>
                        <p class="description">{{translation.resource.description}}</p>
                      </div>
                      <div class="forms__row">
                        <label>Language</label>
                        <mibp-resource-string [key]="'Global_LanguageName_' + languageCode"></mibp-resource-string>
                      </div>
                      @if (!isHtml) {
                        <div class="forms__row">
                          <label>Value @if (isWorking) {
                            <mibp-loader></mibp-loader>
                          }</label>
                          <input type="text" #textElement formControlName="value" />
                        </div>
                      }
                      @if (isHtml) {
                        <div class="forms__row">
                          <label>Value @if (isWorking) {
                            <mibp-loader type='spinner'></mibp-loader>
                          }</label>
                          <textarea #textareaElement  formControlName="value" style="height: 8em;width: 100%;"></textarea>
                        </div>
                      }
                      @if (translation.resource.key.indexOf('ProductName_') === 0) {
                        <mibp-system-message [messageType]="msg.Types.Information" #msg>
                          <p><strong>NOTE!</strong> The Product translations requires the page to be reloaded for the change to be seen</p>
                        </mibp-system-message>
                      }
                      <button type="submit" [hidden]="true" (click)="onSubmit($event)"></button>
                      <button class="my-button" (click)="onSubmit($event)"><mibp-resource-string key="Global_Save"></mibp-resource-string></button>
                      &nbsp;
                      <button type="button" class="my-button my-button--secondary" (click)="cancelEdit()"><mibp-resource-string key="Global_CancelButton"></mibp-resource-string></button>
                    </div>
                  }
                </form>
              }
            </div>
          </div>
        }
        <div style="max-height: 400px; min-height: 400px; overflow-y: scroll;">
          @if (resourceStringResult) {
            <mibp-data-view [bind]="resourceStringResult" #result>
              <div isSuccess>
                <table class="resource-strings">
                  <thead>
                    <tr>
                      <th>Key</th>
                      <th>Description</th>
                      <th colspan="2">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (resource of result.data; track resource) {
                      <tr [class.not-translated]="!resource.isTranslated" [class.is-translated]="resource.isTranslated">
                        <td><a href="javascript:void(0)" (click)="showEditor(resource.key)">{{resource.key}}</a></td>
                        <td>{{resource.description}}</td>
                        <td class="icon" [attr.title]="!resource.isTranslated ? 'Resource is not translated' : ''">
                          <span translate="no" class="material-icon">{{resource.isTranslated ? 'done' : 'close'}}</span>
                        </td>
                        <td [attr.title]="resource.value">{{resource.value | truncateString:25}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </mibp-data-view>
          }
        </div>
        <form  [formGroup]="optionsForm">
          <div class="checkbox">
            <input type="checkbox" (change)="editorModeChange(cbx.checked)" #cbx id="editorEnabled" formControlName="editorEnabled" name="editorEnabled" />
            <label for="editorEnabled">
              Enable page editor tools
            </label>
          </div>
        </form>
      </mibp-refiner>
    }

  </div>



</mibp-dialog>
